import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 이용권 환불
 *
 * Origin: pageNicolasApi.refundTicket
 * API: POST /api/v1/store/coupon_history/refund
 */
export async function postStoreCouponHistoryRefund(
  {
    ticketUid,
  }: {
    ticketUid: string;
  },
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/coupon_history/refund',
    {
      method: 'POST',
      data: {ticketUid},
    },
    options
  );
  return response.data;
}
